// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2al3D","noInteraction":"EventWrapper_noInteraction__3suBh","pointerPassthrough":"EventWrapper_pointerPassthrough__U1l8d"};